export default __webpack_public_path__ + "static/GeekSquad-08629a6a724040b1f1c9c75cc7b8f0d2.png";